// Third Party Imports
import React from 'react';
import {Button} from '@homeaway/react-buttons';
import {ButtonPrimary} from '@homeaway/react-buttons';
import {FormInput, FormTextArea} from '@homeaway/react-form-components';
import FormSelect from '@homeaway/react-form-select';
import Modal from '@homeaway/react-modal';

// Relative Imports
import './IneligibleHelpForm.less';
import AlertBox from '../Alert/Alert';
import {BusinessTypeInput, PropertyCountInput, VatChoiceInput} from '../utils/helpUtil';
import ReCAPTCHA from 'react-google-recaptcha';
import {getKey} from '../utils/commonUtil';

const IneligibleHelpForm = (props) => {
    let {
        translations,
        isIneligibleStatus,
        serviceError,
        serviceSuccess,
        appActions,
        handleAlertDismiss,
        firstNameVal,
        lastNameVal,
        emailVal,
        companyNameVal,
        helpMessageVal,
        helpMessageError,
        handleFieldValOnChange,
        handleFieldValOnBlur,
        scrollTop,
        handleClose,
        isInEligibleModalOpen,
        scrollModalToTop,
        handleSubmit,
        vatNumberChoice,
        phoneNumberVal,
        phoneNumberError,
        companyCountryCode,
        companyCountry,
        onCaptchaChange,
        setRecaptchaRef,
        environment
    } = props;

    const getVatInputClass = () => {
        if (isIneligibleStatus === 'INVALID_BUSINESS_TYPE' || isIneligibleStatus === 'INVALID_VAT_AND_INVALID_BUSINESS_TYPE'
            || isIneligibleStatus === 'INVALID_PROPERTY_COUNT' || isIneligibleStatus === 'INVALID_VAT_NUMBER') {
            return 'sub-content-col';
        }
        return 'content-col';
    };

    const isInvalidPropertyCount = () => isIneligibleStatus === 'INVALID_PROPERTY_COUNT' || isIneligibleStatus === 'INVALID_VAT_NUMBER';

    const isInvalidBusinessType = () => isIneligibleStatus === 'INVALID_BUSINESS_TYPE' || isIneligibleStatus === 'INVALID_VAT_AND_INVALID_BUSINESS_TYPE';

    return (
        <Modal
            id="inEligibleModal"
            isOpen={isInEligibleModalOpen}
            isWorkflow
            onClose={handleClose}
            title={translations['ipmob.ineligible_help.header_1']}
            scrollTop={scrollTop}
            scrollToTop={scrollModalToTop}
        >
            {
                (serviceError || serviceSuccess)
                    ? (
                        <AlertBox
                            messageKey={serviceSuccess || serviceError}
                            translations={translations}
                            handleAlertDismiss={handleAlertDismiss}
                            type={(serviceSuccess) ? 'Alert Success' : 'Alert Error'}
                            targetPage={'Help page'}
                            appActions={appActions}
                        />
                    )
                    : null
            }
            <div className="ineligible-help-form">
                <div className="wrapper">
                    <div className="content-col">
                        <p className="sub-head">
                            {translations['ipmob.ineligible_help.sub_heading']}
                        </p>
                        <div className="wrapper">
                            <div className="content-col">
                                <div className="wrapper">
                                    <div className="sub-content-col">
                                        <FormInput
                                            id="firstName"
                                            type="text"
                                            name="First name"
                                            label={translations['ipmob.create_account.label_3']}
                                            value={firstNameVal}
                                            maxLength="64"
                                        />
                                    </div>
                                    <div className="sub-content-col">
                                        <FormInput
                                            id="lastName"
                                            type="text"
                                            name="Last name"
                                            label={translations['ipmob.create_account.label_4']}
                                            value={lastNameVal}
                                            maxLength="64"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="content-col">
                                <div className="wrapper">
                                    <div className="sub-content-col">
                                        <FormInput
                                            id="email"
                                            type="email"
                                            name="Email"
                                            label={translations['ipmob.create_account.label_5']}
                                            value={emailVal}
                                            maxLength="64"
                                        />
                                    </div>
                                    <div className="sub-content-col">
                                        <FormInput
                                            id="phoneNumber"
                                            type="text"
                                            name="Phone Number"
                                            label={translations['ipmob.create_account.label_8']}
                                            value={phoneNumberVal}
                                            errorMsg={translations[phoneNumberError]}
                                            onChange={handleFieldValOnChange}
                                            onBlur={handleFieldValOnBlur}
                                            maxLength="64"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="content-col">
                                <div className="wrapper">
                                    <div className="sub-content-col">
                                        <FormInput
                                            id="companyName"
                                            type="text"
                                            label={translations['ipmob.create_account.label_2']}
                                            value={companyNameVal}
                                            maxLength="64"
                                        />
                                    </div>
                                    <div className="sub-content-col">
                                        <FormSelect
                                            id="companyLocation"
                                            type="text"
                                            items={[{value: companyCountryCode, label: companyCountry}]}
                                            name="Company location"
                                            label={translations['ipmob.ineligible_help.label_1']}
                                            value={companyCountry}
                                            maxLength="64"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="content-col">
                                <div className="wrapper">
                                    <div className={getVatInputClass()}>
                                        {(vatNumberChoice) ? <VatChoiceInput {...props}/> : null}
                                    </div>
                                    <div className={(vatNumberChoice) ? 'sub-content-col' : 'content-col'}>
                                        {isInvalidPropertyCount() ? <PropertyCountInput {...props}/> : null}
                                        {isInvalidBusinessType() ? <BusinessTypeInput {...props}/> : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="content-col">
                                <h3>
                                    {translations['ipmob.ineligible_help.header_2']}
                                </h3>
                                <FormTextArea
                                    id="helpMessage"
                                    label={`${translations['ipmob.help_page.message']}. . .`}
                                    rows={5}
                                    value={helpMessageVal}
                                    errorMsg={translations[helpMessageError]}
                                    onChange={handleFieldValOnChange}
                                    onBlur={handleFieldValOnBlur}
                                />
                            </div>
                        </div>
                        <div className="mdl-wrapper">
                            <div className="mdl-col-left"/>
                            <div className="mdl-col-captcha">
                                <ReCAPTCHA
                                    ref ={setRecaptchaRef}
                                    sitekey={`${getKey(environment)}`}
                                    size="invisible"
                                    onChange={onCaptchaChange}
                                />
                            </div>
                        </div>
                        <div className="wrapper">
                            <div className="ineligible-modal-btn">
                                <Button
                                    type="reset"
                                    className="cancel-btn"
                                    label={translations['ipmob.ineligible_help.cancel']}
                                    onClick={handleClose}
                                    size="sm"
                                />
                                <ButtonPrimary
                                    type="submit"
                                    className="send-btn"
                                    label={translations['ipmob.help_page.submit']}
                                    size="sm"
                                    onClick={handleSubmit}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>);
};

export default IneligibleHelpForm;
